// Utilitários de formatação (datas, nomes, tamanhos)

/**
 * Data curta para a lista de emails: hora (hoje), "Ontem", dia da semana (< 7 dias) ou dd/mm.
 * Tolerante a datas inválidas, nulas ou futuras.
 */
export function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dayDiff = Math.round((startOfToday - startOfDate) / 86400000);

  if (dayDiff <= 0)
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  if (dayDiff === 1) return 'Ontem';
  if (dayDiff < 7) return date.toLocaleDateString('pt-BR', { weekday: 'short' });
  if (date.getFullYear() !== now.getFullYear())
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' });
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

/** Data completa por extenso para o cabeçalho do email. */
export function formatFullDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/** Iniciais de um nome (ou email) para avatares. Nunca lança com entrada nula. */
export function getInitials(name) {
  if (!name || typeof name !== 'string') return '?';
  const clean = name.trim();
  if (!clean) return '?';
  // Para emails, usa a parte antes do @
  const base = clean.includes('@') ? clean.split('@')[0] : clean;
  const parts = base.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return parts.map(p => p[0]).join('').substring(0, 2).toUpperCase();
}

/** Formata bytes em unidade legível. */
export function formatBytes(bytes) {
  const n = Number(bytes);
  if (!isFinite(n) || n <= 0) return '0 B';
  if (n >= 1073741824) return (n / 1073741824).toFixed(2) + ' GB';
  if (n >= 1048576) return (n / 1048576).toFixed(1) + ' MB';
  if (n >= 1024) return Math.round(n / 1024) + ' KB';
  return Math.round(n) + ' B';
}
